import ReactPlayer from 'react-player'
import { useState, useEffect, useRef } from "react";
import Slider from 'react-touch-drag-slider'
import recoringIcon from "../../images/recoring.png";
import ChangingProgressProvider from "../../components/UI/ChangingProgressProvider"
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import * as _ from "lodash";
import "./Movie.css";

const MoviePanel = (props) => {

  const [played, setPlayed] = useState(0);
  const [loading, setLoading] = useState(true);
  const [playing, setPlaying] = useState(true);
  const [autoplay, setAutoplay] = useState(true);

  const videoRef = useRef([]);
  const [videoIndex, setVideoIndex] = useState(0);
  // const [message, setMessage] = useState("");
  const [moviesUrls, setMoviesUrls] = useState(
    [
      { url: "videos/01title.mp4", loading: true, duration: 0 },
      { url: "videos/02jong.mp4", loading: true, duration: 0 },
      { url: "videos/03knife.mp4", loading: true, duration: 0 },
      { url: "videos/04doma.mp4", loading: true, duration: 0 },
      { url: "videos/05eyez.mp4", loading: true, duration: 0 },
      { url: "videos/06door.mp4", loading: true, duration: 0 },
      { url: "videos/07scary.mp4", loading: true, duration: 0 },
      { url: "videos/08eyez.mp4", loading: true, duration: 0 },
      { url: "videos/09duldul.mp4", loading: true, duration: 0 },
      { url: "videos/10foko.mp4", loading: true, duration: 0 },
      { url: "videos/11shoe.mp4", loading: true, duration: 0 },
      { url: "videos/12ghost.mp4", loading: true, duration: 0 },
      { url: "videos/13walk.mp4", loading: true, duration: 0 },
      { url: "videos/14tran.mp4", loading: true, duration: 0 },
      { url: "videos/15back.mp4", loading: true, duration: 0 },
      { url: "videos/16wou.mp4", loading: true, duration: 0 },
      { url: "videos/17look.mp4", loading: true, duration: 0 },
      { url: "videos/18end.mp4", loading: true, duration: 0 },
      { url: "videos/19tv.mp4", loading: true, duration: 0 },
      { url: "videos/20fin.mp4", loading: true, duration: 0 },
    ]
  );


  useEffect(() => {
    // console.log('useEffect');
    videoRef.current = videoRef.current.slice(0, moviesUrls.length);
  }, [videoRef]);


  const isLoading = () => {
    if (!loading) {
      return false;
    } else {
      for (let i = 0; i < moviesUrls.length; i++) {
        if (moviesUrls[i].loading) {
          return true;
        }
      }
      setLoading(false);
      return false;
    }
  }

  const toggleAutoPlay = (e) => {
    if (!autoplay && (played <= 0 || played >= 1)) {
      let incrementVideoIndex = videoIndex + 1;
      if (incrementVideoIndex < moviesUrls.length) {
        setVideoIndex(incrementVideoIndex);
      }
      setPlaying(true);
    } else {

    }
    setAutoplay(!autoplay);
  };

  const onVideoEnded = (index) => {
    // setMessage(message + 'onVideoEnded ' + index + ",   ");
    if (!isLoading()) {
      if (index === videoIndex) {
        if (autoplay) {
          let incrementVideoIndex = videoIndex + 1;
          if (incrementVideoIndex < moviesUrls.length) {
            // videoRef.current[incrementVideoIndex].seekTo(0);
            setVideoIndex(incrementVideoIndex);
            setPlaying(true);
          } else {
            setAutoplay(false);
            setPlaying(false);
          }
        } else {
          setPlaying(false);
        }
        // played = 0;
        setPlayed(0);
      }
    } else {
      let clonedMoviesUrls = _.cloneDeep(moviesUrls);
      clonedMoviesUrls[index].loading = false;
      setMoviesUrls(clonedMoviesUrls);
      videoRef.current[index].seekTo(0);
    }
  }

  const setShowIndexVideo = (newIndex) => {
    // setMessage(message + 'setShowIndexVideo' + ",   ");
    if (newIndex < moviesUrls.length) {
      videoRef.current[videoIndex].seekTo(0);
      setVideoIndex(newIndex);
      // played = 0;
      setPlayed(0);
      setPlaying(true);
    }
  }

  const handleProgress = (e, index) => {
    // console.log('handleProgress', e, index);
    // setMessage(message + 'handleProgress ' + e.played + ",   ");
    if (!isLoading() && index === videoIndex) {
      if (e.played !== 0) {
        // played = e.played;
        setPlayed(e.played);
      }
    } else {
      let clonedMoviesUrls = _.cloneDeep(moviesUrls);
      // if (e.played > (0.1 / clonedMoviesUrls[index].duration)) {
      if (e.played > 0) {
        clonedMoviesUrls[index].loading = false;
        setMoviesUrls(clonedMoviesUrls);
        videoRef.current[index].seekTo(0);
      }
    }
  }

  const handleDuration = (e, index) => {
    // setMessage(message + 'handleProgress ' + e.played + ",   ");
    // console.log('handleDuration', e, index);
    let clonedMoviesUrls = _.cloneDeep(moviesUrls);
    if (isLoading()) {
      clonedMoviesUrls[index].duration = e;
      setMoviesUrls(clonedMoviesUrls);
    }
  }


  const onClickHandler = e => {
    setPlaying(!playing);
  }

  return (
    <div
      style={{
        height: '100vh',
        background: 'black',
        overflow: 'hidden'
      }}
    >
      <div
        style={{
          height: '5%',
          margin: 20
        }}
      >
        <img
          src={recoringIcon}
          width={"12%"}
          className={autoplay ? "rotate" : ""}
          style={{
            borderRadius: 0,
            margin: 0,
            paddingLeft: 0,
            display: "flex",
          }}
          onClick={e => toggleAutoPlay(e)}
        />
      </div>
      <div
        style={{
          height: '90%',
          backgroundSize: 'cover',
          margin: '40px 0px'
        }}
      >
        <div
          style={{
            width: '100%',
            height: '80%'
          }}
          onClick={onClickHandler}
        >
          <div
            style={{
              position: 'absolute',
              left: '50%',
              top: '50%',
              transform: 'translate(-50%, -50%)',
              display: isLoading() ? "block" : "none"
            }}
          >
            <ChangingProgressProvider values={[0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100]}>
              {percentage => (
                <CircularProgressbar
                  value={percentage}
                  text={`loading`}
                  styles={buildStyles({
                    textColor: "grey",
                    pathColor: "white",
                    trailColor: "grey"
                  })}
                />
              )}
            </ChangingProgressProvider>
          </div>

          <Slider
            activeIndex={videoIndex}
            transition={autoplay ? 0 : 0.5}
            scaleOnDrag={false}
            style={{ height: '100px' }}
            dragEnabled={false}
            touchEnabled={false}
            threshHold={10}
            onSlideComplete={(i) => {
              // console.log('onSlideComplete', playing);
              if (i !== videoIndex) {
                setShowIndexVideo(i);
              } else {
                // setPlaying(!playing);
              }
            }}
            onSlideStart={(i) => {
              // console.log('onSlideStart');
            }}
          >
            {
              moviesUrls.map((url, index) => (
                <ReactPlayer
                  key={index}
                  ref={el => videoRef.current[index] = el}
                  url={moviesUrls[index].url}
                  width="100%"
                  height="100%"
                  controls={false}
                  playsinline={true}
                  loop={false}
                  playing={moviesUrls[index].loading === true || (!isLoading() && (index === videoIndex) && playing)}
                  volume={(!isLoading() && index === videoIndex && playing) ? 1 : 0}
                  onProgress={(e) => { handleProgress(e, index) }}
                  onDuration={(e) => { handleDuration(e, index) }}
                  progressInterval={1000}
                  onEnded={() => onVideoEnded(index)}
                  // onBuffer={() => setMessage(message + 'onBuffer' + ",   ")}
                  // onStart={() => setMessage(message + 'onStart: ' + played + ",   ")}
                  // onError={(e) => setMessage(message + 'onError' + ' ' + index + ' ' + videoIndex + e)}
                  // muted={(index === videoIndex && (played === 0 || played === 1))}
                  config={{
                    file: { preload: 'auto' },
                    attributes: {
                      autoPlay: false,
                      controls: false,
                    }
                  }}
                  // style={{ display: "none" }}
                  // style={{ display: (played === 0 || played === 1 || index !== videoIndex) ? "none" : "block" }}
                  style={{ display: (isLoading()) ? "none" : "block" }}
                />
              ))}
          </Slider>
        </div>
        {/* <div style={{ color: 'white' }}>
          {message}
        </div> */}
      </div>
    </div>
  );
};

export default MoviePanel;
